export default __webpack_public_path__ + "static/media/Drazo1.94dfd7d8.jpeg";